import React, {useEffect, useState} from 'react';
import PropTypes from 'prop-types';
import {useKeycloak} from '@react-keycloak/web';
import {useIntl} from 'react-intl';

import {message, Select} from 'antd';
import {findDiseaseById, findDiseases} from 'services/DiseaseService';
import {EQUAL, IGNORE_CASE_LIKE} from 'shared/constants/QueryModes';
import {QUERY_SIZE_LIMIT} from 'shared/constants/AppConst';
import {handleError} from 'utils/MessageUtils';

const DiseaseSelect = (props) => {
  const {keycloak} = useKeycloak();
  const intl = useIntl();
  const headers = {
    Authorization: `Bearer ${keycloak?.token}`,
    'Accept-Language': intl.locale,
  };

  const [data, setData] = useState([]);
  const {value} = props;
  const [searchValue, setSearchValue] = useState();

  useEffect(() => {
    if (value && !data.find((item) => item.value === value)) {
      findDiseaseById(headers, value)
        .then((res) => {
          setData([
            {
              value,
              text: res.data.name,
            },
          ]);

          setSearchValue(`${res.data.code} - ${res.data.name}`);
        })
        .catch((error) => handleError(message, error));
    }
  }, [value]);

  const handleSearch = (newValue) => {
    setSearchValue(newValue);
    if (newValue) {
      findDiseases(headers, {
        filters: [
          {
            fields: ['code', 'name'],
            mode: IGNORE_CASE_LIKE,
            value: newValue,
          },
          {
            fields: 'enabled',
            mode: EQUAL,
            value: true,
          },
        ],
        pagination: {current: 1, pageSize: QUERY_SIZE_LIMIT},
      })
        .then((res) => {
          setData(
            res.data.map((item) => ({
              value: item.code,
              text: item.name,
            })),
          );
        })
        .catch((error) => handleError(message, error));
    } else {
      setData([]);
    }
  };

  const options = data.map((d) => (
    <Select.Option key={d.value}>
      {d.value} - {d.text}
    </Select.Option>
  ));

  return (
    <Select
      mode={props.mode}
      searchValue={searchValue}
      showSearch
      showArrow={false}
      allowClear
      filterOption={false}
      onSearch={handleSearch}
      onChange={props.onChange}
      onClear={props.onClear}
      notFoundContent={null}
      disabled={props.disabled}>
      {options}
    </Select>
  );
};

export default DiseaseSelect;

DiseaseSelect.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func,
  onClear: PropTypes.func,
  mode: PropTypes.string,
  disabled: PropTypes.bool,
};
